var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9497 14.455C17.6834 11.7201 17.6834 7.28601 14.9497 4.55115C12.2161 1.81628 7.78392 1.81628 5.05025 4.55115C2.31658 7.28601 2.31658 11.7201 5.05025 14.455L6.57128 15.9538L8.61408 17.9389L8.74691 18.0567C9.52168 18.6847 10.6562 18.6455 11.3861 17.9391L13.8223 15.5691L14.9497 14.455ZM10 12.5C8.34315 12.5 7 11.1569 7 9.5C7 7.84315 8.34315 6.5 10 6.5C11.6569 6.5 13 7.84315 13 9.5C13 11.1569 11.6569 12.5 10 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointer);
export default __webpack_public_path__ + "static/media/location-pointer.b596a912.svg";
export { ForwardRef as ReactComponent };